import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
const Courses = ({ courses, isAdmin }) => {
 const { deleteCourse, updateCourse } = useContext(UserContext);

 const [show, setShow] = useState(false);
 const [title, setTitle] = useState("");
 const [description, setDescription] = useState("");
 const [id, setId] = useState("");

 const handleShowUpdate = async (id) => {
  try {
   const check = await courses.find((course) => course._id === id);

   setShow((prev) => !prev);
   setId(id);
   setTitle(check.title);
   setDescription(check.description);
  } catch (error) {
   console.log(error);
  }
 };

 const handleUpdate = async (e) => {
  e.preventDefault();
  updateCourse({ id, title, description });
 };
 return (
  <div className="courses">
   {show && (
    <div>
     <h1>Update Course</h1>
     <form onSubmit={handleUpdate}>
      <input
       type="text"
       value={title}
       onChange={(e) => setTitle(e.target.value)}
      />
      <input
       type="text"
       value={description}
       onChange={(e) => setDescription(e.target.value)}
      />
      <button>Update</button>
     </form>
    </div>
   )}

   <h1>List of Courses</h1>
   <div className="courses-lists">
    {courses?.map((course, i) => (
     <div className="course" key={i}>
      <h2 className="title">{course.title}</h2>
      <p className="description">{course.description}</p>
      {isAdmin && (
       <p>
        <span onClick={() => deleteCourse(course._id)}>delete</span>
        <span onClick={() => handleShowUpdate(course._id)}>Update</span>
       </p>
      )}

      <hr />
     </div>
    ))}
   </div>
  </div>
 );
};

export default Courses;
